import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import WarningIcon from "@mui/icons-material/Warning";
import {
  BUTTON_SEE_MORE,
  CONTENT_WARNING_TITLE,
  SUGGESTED_CREATIVES_PROGRESS,
} from "../../i18n/keysTranslations";
import { useTranslationApp } from "../../lib/i18next";
import { BORDER_RADIUS } from "../../utils/constants";
import { GRAY_200, GRAY_50, GRAY_900 } from "../../utils/colors";

const ContentRecommendationsBanner = ({
  contentRecommendations,
  validMediaUrlsCount,
  suggestedCreativesCount = null,
  onSeeMore,
}) => {
  const { t } = useTranslationApp();

  return (
    <Paper
      elevation={0}
      sx={{
        bgcolor: GRAY_50,
        border: `1px solid ${GRAY_200}`,
        borderRadius: BORDER_RADIUS,
        p: 2,
        position: "relative",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1.5 }}>
        <Box
          sx={{
            px: 1,
            pb: 1,
            pt: 0.5,
            bgcolor: GRAY_900,
            borderRadius: 1,
            flexShrink: 0,
          }}
        >
          <WarningIcon sx={{ fontSize: 18, color: "#fff !important" }} />
        </Box>
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            gap: 1,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 1,
            }}
          >
            <Typography
              variant="body2"
              sx={{
                fontSize: "16px",
                fontWeight: 600,
              }}
            >
              {t(CONTENT_WARNING_TITLE)}
            </Typography>
            {suggestedCreativesCount !== null && (
              <Box
                sx={{
                  px: 1,
                  py: 0.5,
                  fontSize: "12px",
                  fontWeight: 500,
                  bgcolor: GRAY_900,
                  color: "#fff !important",
                  borderRadius: BORDER_RADIUS,
                }}
              >
                {t(SUGGESTED_CREATIVES_PROGRESS, {
                  current: validMediaUrlsCount,
                  total: suggestedCreativesCount,
                })}
              </Box>
            )}
          </Box>

          <Typography
            sx={{
              fontSize: "14px",
              lineHeight: 1.5,
              overflow: "hidden",
              display: "-webkit-box",
              WebkitLineClamp: 3,
              WebkitBoxOrient: "vertical",
              textOverflow: "ellipsis",
            }}
          >
            {contentRecommendations.map((rec) => rec.text).join(" ")}
          </Typography>

          <Typography
            variant="body2"
            onClick={onSeeMore}
            sx={{
              fontSize: "14px",
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            {t(BUTTON_SEE_MORE)} ...
          </Typography>
        </Box>
      </Box>
    </Paper>
  );
};

export default ContentRecommendationsBanner;
